<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <el-tabs v-model="activeName">
      <el-tab-pane label="声乐器乐考级" name="vocalCheck">
        <vocal/>
      </el-tab-pane>
      <el-tab-pane label="音基考级" name="musicbasisCheck">
        <musicbasis :activeName="activeName"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Vocal from './musicbasisResule/vocal'
import Musicbasis from './musicbasisResule/musicbasis'

export default {
  name: 'list',
  components: { Vocal, Musicbasis },
  props: [],
  data () {
    return {
      activeName: 'vocalCheck'
    }
  },
  async created () {
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {}
}
</script>
